/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HistoryAction {
  Insert = 'I',
  Update = 'U',
  Delete = 'D',
}
